export const settingsPath = () => "/settings";
export const settingsApiKeysPath = () => "/settings/api-keys";
export const settingsProfilePath = () => "/settings/profile";
export const settingsBranchPath = () => "/settings/branch";
